import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowCircleRightIcon } from '@heroicons/react/solid';
import { NavLink, Route, Link } from 'react-router-dom';
import Slider from 'react-slick';
import Footer from '../layouts/Footer';
import LogoSlider from '../components/LogoSlider';
import ProjectModal from '../components/ProjectModal';

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 2000,
  cssEase: 'linear',
};

export default function MainPage() {
  const [t, i18n] = useTranslation('common');
  const dataMain = [
    {
      id: 1,
      headTitle: `${t('welcome.eTheadTitle')}`,
      title: `${t('welcome.eTtitle')}`,
      image: '/Pro1Head.png',
      desc: `${t('welcome.eTdesc')}`,
      headImage: '1p.png',
    },
  ];

  const data = [
    {
      id: 2,
      headTitle: `${t('welcome.airRheadTitle')}`,
      title: `${t('welcome.airRtitle')}`,
      image: '/niseh.jpg',
      desc: `${t('welcome.airRdesc')}`,
      headImage: '/nisehHead.jpg',
    },
    {
      id: 3,
      headTitle: `${t('welcome.ubRheadTitle')}`,
      title: `${t('welcome.ubRtitle')}`,
      image: '/Pro3Desc.jpeg',
      desc: `${t('welcome.ubRdesc')}`,
      headImage: '6p.png',
    },
  ];
  const FirstData = [
    {
      id: 1,
      headTitle: `${t('welcome.mglseoheadTitle')}`,
      title: `${t('welcome.mglseotitle')}`,
      image: '/mglseo.png',
      desc: `${t('welcome.mglseodesc')}`,
      headImage: '/mglseo.png',
    },
    {
      id: 2,
      headTitle: `${t('welcome.PremheadTitle')}`,
      title: `${t('welcome.Premtitle')}`,
      image: '/Prem.png',
      desc: `${t('welcome.Premdesc')}`,
      headImage: 'Prem.png',
    },
  ];
  const SecondData = [
    {
      id: 1,
      headTitle: `${t('welcome.AutoTeeverheadTitle')}`,
      title: `${t('welcome.AutoTeevertitle')}`,
      image: '/autoteever.png',
      desc: `${t('welcome.AutoTeeverdesc')}`,
      headImage: '/autoteever.png',
    },
    {
      id: 2,
      headTitle: `${t('welcome.TsahilgaanheadTitle')}`,
      title: `${t('welcome.Tsahilgaantitle')}`,
      image: '/tsahilgaan.png',
      desc: `${t('welcome.Tsahilgaandesc')}`,
      headImage: 'tsahilgaan.png',
    },
  ];
  const [text, setText] = useState('');
  const [fullText, setFullText] = useState(`${t('welcome.mrgGroupText')}`);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (index < fullText.length) {
      setTimeout(() => {
        setText(text + fullText[index]);
        setIndex(index + 1);
      }, 40);
    }
  }, [index]);

  const [textMrg, setTextMrg] = useState('');
  const [fullTextMrg, setFullTextMrg] = useState(`${t('welcome.mrgGroup')}`);
  const [indexMrg, setIndexMrg] = useState(0);
  useEffect(() => {
    if (indexMrg < fullTextMrg.length) {
      setTimeout(() => {
        setTextMrg(textMrg + fullTextMrg[indexMrg]);
        setIndexMrg(indexMrg + 1);
      }, 40);
    }
  }, [index]);

  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [image, setImage] = useState('');

  const [slideLeft, setSlideLeft] = useState(0);
  const [hideButtonLeft, setHideButtonLeft] = useState(true);
  const [hideButtonRight, setHideButtonRight] = useState(false);
  const [sliderWidth, setSliderWidth] = useState(0);
  const [count, setCount] = useState(1);

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = (id) => {
    setTitle(data[id].title);
    setDesc(data[id].desc);
    setImage(data[id].image);
    setIsOpen(true);
  };
  const openModalFirstData = (id) => {
    setTitle(FirstData[id].title);
    setDesc(FirstData[id].desc);
    setImage(FirstData[id].image);
    setIsOpen(true);
  };
  const openModalSecondData = (id) => {
    setTitle(SecondData[id].title);
    setDesc(SecondData[id].desc);
    setImage(SecondData[id].image);
    setIsOpen(true);
  };
  const openModalMain = (id) => {
    setTitle(dataMain[id].title);
    setDesc(dataMain[id].desc);
    setImage(dataMain[id].image);
    setIsOpen(true);
  };

  useEffect(() => {
    // console.log("offsetWidth" , document.getElementById('hscroll').offsetWidth)
    // console.log("clientWidth" , document.getElementById('hscroll').clientWidth)
    // console.log("scrollWidth" , document.getElementById('hscroll').scrollWidth)
    setSliderWidth(document.getElementById('hscroll').scrollWidth - document.getElementById('hscroll').offsetWidth);
  }, []);

  const moveRight = () => {
    const el = document.getElementById(`hscroll`);
    setSlideLeft((el.scrollLeft += 200));
  };

  const moveLeft = () => {
    const el = document.getElementById(`hscroll`);
    setSlideLeft((el.scrollLeft -= 200));
  };

  const onHScroll = () => {
    const el = document.getElementById(`hscroll`).scrollLeft;
    /* eslint-disable */
    if (0 < el && el < 148) {
      setCount(1);
    }
    console.log(el);
    if (160 < el && el < 400) {
      setCount(2);
    }
    if (401 < el && el < 612) {
      setCount(3);
    }
    if (el > 0) {
      setHideButtonLeft(false);
    } else {
      setHideButtonLeft(true);
    }
    if (el < sliderWidth) {
      setHideButtonRight(false);
    } else {
      setHideButtonRight(true);
    }
    /* eslint-enable */
    console.log(count);
  };
  const brief = `${t('welcome.mainBriefDesc')}`;
  return (
    <div id="overlayBack">
      <div className="relative">
        <main className="flex-grow">
          <div className="w-full bg-center bg-cover h-2/4 md:h-2/4 ">
            <div className="relative group">
              <video
                preload
                autoPlay
                muted
                loop
                playsInline
                poster=""
                className="video h-full lg:h-96 lg:object-fill w-full"
              >
                <source src="/video5.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="absolute font-montserrat text-opacity-80 left-0 bottom-[71%] right-0 z-10 flex justify-center items-end text-[14px] lg:text-[20px] text-white font-normal">
                {textMrg}
              </div>
              <div className="absolute font-montserrat text-opacity-80 left-0 bottom-[38%] right-0 z-10 flex justify-center items-end text-[21px] lg:text-[40px] text-white font-light">
                {text}
              </div>
            </div>
          </div>
          <div>
            <div className="py-20 bg-white">
              <div className="flex flex-col px-8 mx-auto space-y-12 max-7-xl">
                <div className="relative">
                  <div className="w-3/4 flex items-center lg:w-3/5 mx-auto flex-row flex-col">
                    <img src="/mrg2.png" className="w-28 object-cover object-right-top" alt="mrg" />
                  </div>
                  <h1 className="title-font font-extralight text-gray-900 text-3xl text-center sm:text-3xl md:text-4xl ">
                    {t(`welcome.mainBrief`)}
                  </h1>
                  <p
                    className="w-full py-8 mx-auto -mt-2 text-lg text-center text-gray-500 intro sm:max-w-3xl"
                    dangerouslySetInnerHTML={{ __html: brief }}
                  />
                </div>
              </div>
            </div>

            <div className="py-10 bg-gray-100">
              <div className="flex flex-col px-8 mx-auto space-y-12 max-7-xl">
                <div className="relative">
                  <h1 className="title-font font-extralight text-gray-600 text-3xl text-center sm:text-3xl md:text-3xl ">
                    <NavLink key={'Company'} to={'/Company'}>
                      {t(`welcome.mainBus`)}
                    </NavLink>
                  </h1>
                  <p className="w-full py-8 mx-auto -mt-2 text-lg text-center text-gray-500 intro sm:max-w-3xl">
                    {t(`welcome.mainBusDesc`)}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-3 text-gray-700 body-font w-4/4 flex items-center lg:w-5/5 md:w-3/4 md:w-3/5 mx-auto flex-row flex-col">
                <div className="flex items-center flex-col px-1 py-5 mx-auto">
                  <Link to="/Company">
                    <div className="flex sm:w-32 sm:h-32 h-20 w-20 inline-flex items-center justify-center rounded-full bg-gray-100 text-gray-500 flex-shrink-0 ">
                      <Construction />
                    </div>
                  </Link>
                  <div className="flex justify-center flex-grow sm:text-left text-center mt-6 sm:mt-4 ">
                    <h2 className="text-gray-600 text-lg title-font font-normal mb-2">
                      <NavLink key={'Subsidiary10'} to={'/Company'}>
                        {t(`welcome.menuCon`)}
                      </NavLink>
                    </h2>
                  </div>
                </div>
                <div className="flex items-center flex-col px-1 py-5 mx-auto">
                  <Link to="/Company">
                    <div className="flex sm:w-32 sm:h-32 h-20 w-20 inline-flex items-center justify-center rounded-full bg-gray-100 text-gray-500 flex-shrink-0 ">
                      <Mining />
                    </div>
                  </Link>
                  <div className="flex justify-center flex-grow sm:text-left text-center mt-6 sm:mt-4 ">
                    <h2 className="text-gray-600 text-lg title-font font-normal mb-2 pl-3">
                      <NavLink key={'Subsidiary10'} to={'/Company'}>
                        {t(`welcome.menuMine`)}
                      </NavLink>
                    </h2>
                  </div>
                </div>
                <div className="flex items-center flex-col px-1 py-5 mx-auto">
                  <Link to="/Company">
                    <div className="flex sm:w-32 sm:h-32 h-20 w-20 inline-flex items-center justify-center rounded-full bg-gray-100 text-gray-500 flex-shrink-0 ">
                      <It />
                    </div>
                  </Link>
                  <div className="flex justify-center flex-grow sm:text-left text-center mt-6 sm:mt-4 ">
                    <h2 className="text-gray-600 text-lg title-font font-normal mb-2">
                      <NavLink key={'Subsidiary10'} to={'/Company'}>
                        {t(`welcome.menuMineIt`)}
                      </NavLink>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="py-24 ">
            <div className="flex flex-col px-8 mx-auto space-y-12 max-7-xl mb-10">
              <div className="relative">
                <h1 className="title-font font-extralight text-gray-600 text-3xl text-center sm:text-3xl md:text-3xl">
                  <NavLink key={'Subsidiary1'} to={'/Company'}>
                    {t(`welcome.mainSubCom`)}
                  </NavLink>
                </h1>
              </div>
            </div>
            <h1 className="pr-5 title-font text-lg text-right font-medium text-gray-600 mb-5 lg:invisible ">
              {count}/3
            </h1>

            <div className="flex flex-col bg-white m-auto p-auto ">
              <div
                className="flex lg:justify-center overflow-x-scroll pb-10 hide-scroll-bar"
                id="hscroll"
                onScroll={() => onHScroll()}
              >
                <div className="flex flex-nowrap">
                  <div className="inline-block px-3">
                    <div className="w-80 lg:h-[480px] md:h-[460px] max-w-xs overflow-hidden rounded-lg shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out">
                      <img
                        className="lg:h-48 md:h-36 w-full object-scale-down object-center scale-110 transition-all duration-400 hover:scale-100"
                        src="/mrg14.png"
                        alt="mrg"
                      />
                      <div className="p-6 h-[240px]">
                        <h1 className="title-font text-lg font-medium text-gray-600 mb-3">
                          <NavLink key={'mrgLink'} to={'/Company'}>
                            {t(`welcome.mainSubComMrg`)}
                          </NavLink>
                        </h1>
                        <p className="leading-relaxed mb-3">{t(`welcome.mainSubComMrgDesc`)}</p>
                      </div>
                      <div>
                        <button type="button" className="px-6 text-sky-500 mb-3">
                          <NavLink key={'mrgLink10'} to={'/Company'}>
                            {t(`welcome.readMore`)}
                          </NavLink>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="inline-block px-3">
                    <div className="w-80 lg:h-[480px] md:h-[460px] max-w-xs overflow-hidden rounded-lg shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out">
                      <img
                        className="lg:h-48 md:h-36 w-full object-scale-down object-center scale-110 transition-all duration-400 hover:scale-100"
                        src="/core4.png"
                        alt="mrg"
                      />
                      <div className="p-6 h-[240px]">
                        <h1 className="title-font text-lg font-medium text-gray-600 mb-3">
                          <NavLink key={'mrgLink'} to={'/Company'}>
                            {t(`welcome.mainSubComCore`)}
                          </NavLink>
                        </h1>
                        <p className="leading-relaxed mb-3">{t(`welcome.mainSubComCoreDesc`)}</p>
                      </div>
                      <div>
                        <button type="button" className="px-6 text-sky-500 mb-3">
                          <NavLink key={'mrgLink10'} to={'/Company'}>
                            {t(`welcome.readMore`)}
                          </NavLink>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="inline-block px-3">
                    <div className="w-80 lg:h-[480px] md:h-[460px] max-w-xs overflow-hidden rounded-lg shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out">
                      <img
                        className="lg:h-48 md:h-36 w-full object-scale-down object-center scale-110 transition-all duration-400 hover:scale-100"
                        src="/ing1.png"
                        alt="mrg"
                      />
                      <div className="p-6 h-[240px]">
                        <h1 className="title-font text-lg font-medium text-gray-600 mb-3">
                          <NavLink key={'mrgLink'} to={'/Company'}>
                            {t(`welcome.mainSubComIng`)}
                          </NavLink>
                        </h1>
                        <p className="leading-relaxed mb-3">{t(`welcome.mainSubComIngDesc`)}</p>
                      </div>
                      <div>
                        <button type="button" className="px-6 text-sky-500 mb-3">
                          <NavLink key={'mrgLink10'} to={'/Company'}>
                            {t(`welcome.readMore`)}
                          </NavLink>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <ul className="no-scrollbar flex items-center justify-center overflow-scroll">
                <li className=" p-3 px-8"><a href="#1">•</a></li>
                <li className=" p-3 px-8"><a href="#1">•</a></li>
                <li className=" p-3 px-8"><a href="#1">•</a></li>
              </ul> */}
            </div>
          </div>

          <div className="flex flex-col px-8 mx-auto space-y-12 max-7-xl ">
            <div className="relative">
              <h1 className="title-font font-extralight text-gray-600 text-3xl text-center sm:text-3xl md:text-3xl ">
                <NavLink key={'Projects'} to={'/Projects'}>
                  {t(`welcome.projectsTitle`)}
                </NavLink>
              </h1>
            </div>
          </div>
          <div className="flex items-center justify-center lg:p-10 bg-white">
            <div className="container grid xl:w-10/12 2xl:w-4/6 max-sm:w-11/12 max-xl:w-11/12 gap-8 lg:grid-cols-2 lg:grid-rows-2">
              <div
                aria-hidden="true"
                onClick={() => openModalMain(0)}
                className="row-span-2 flex flex-col rounded-md border border-slate-200"
              >
                <div className="h-1/2 flex-1">
                  <img src={dataMain[0].image} className="w-full  object-right-top" alt="2.png" />
                </div>
                <div className="p-5">
                  <h3 className="text-xl font-medium text-gray-700">{dataMain[0].title}</h3>
                  <p className="mt-2 text-slate-500">{dataMain[0].headTitle}</p>
                  <button type="button" onClick={() => openModalMain(0)} className="mt-2 inline-flex text-sky-500">
                    {t(`welcome.readMore`)}
                  </button>
                </div>
              </div>
              {data.map((data, i) => {
                return (
                  <>
                    <div
                      aria-hidden="true"
                      onClick={() => openModal(i)}
                      className="flex border-b lg:border md:border border-slate-200 lg:rounded-md lg:border pb-5 lg:pb-0 md:pb-0 lg:border-slate-200"
                    >
                      <div className="relative h-full w-1/5 overflow-hidden lg:hidden md:hidden lg:block">
                        <div className="absolute inset-0  flex items-center justify-center">
                          <img
                            src={data.headImage}
                            className="h-2/4 w-3/5 lg:h-full lg:w-full  object-left-top lg:object-left-top"
                            alt=""
                          />
                        </div>
                      </div>

                      <div className="flex-1 lg:p-10 lg:hidden md:hidden lg:block">
                        <h3 className="text-[12px] lg:text-xl font-medium text-gray-700">{data.title}</h3>
                        <p className="text-[10px] mt-2 text-slate-500">
                          {data.headTitle.substring(0, 147).concat('...')}
                        </p>
                      </div>
                      <div className="relative h-full w-1/5 overflow-hidden lg:hidden md:hidden lg:block">
                        <div className="absolute inset-0 flex items-center justify-center">
                          <ArrowCircleRightIcon
                            className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                        </div>
                      </div>

                      <div className="flex-1 p-5 hidden sm:block">
                        <h3 className="text-xl font-medium text-gray-700">{data.title}</h3>
                        <p className="mt-2 text-slate-500">{data.headTitle.substring(0, 97).concat('...')}</p>
                        <button type="button" onClick={() => openModal(1)} className="mt-2 inline-flex text-sky-500">
                          {t(`welcome.readMore`)}
                        </button>
                      </div>
                      <div className="relative hidden h-full w-1/3 overflow-hidden hidden sm:block">
                        <div className="absolute inset-0">
                          <img src={data.headImage} className="h-full w-full object-cover object-left-top" alt="" />
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div className="py-5 ">
            <div className="flex flex-col px-8 mx-auto space-y-12 max-7-xl">
              <div className="relative">
                <h1 className="title-font font-extralight text-gray-600 text-3xl text-center sm:text-3xl md:text-3xl ">
                  <NavLink key={'Subsidiary1'} to={'/Projects'}>
                    {t(`welcome.ourCust`)}
                  </NavLink>
                </h1>
              </div>
            </div>

            <div className="flex flex-col px-8 mx-auto space-y-12 xl:w-10/12 2xl:w-4/6 max-sm:w-full max-xl:w-11/12">
              <div className="relative">
                <div className="w-full">
                  <LogoSlider />
                </div>
              </div>
            </div>
          </div>

          <div className="py-1 bg-white">
            <Footer />
          </div>
        </main>
        <ProjectModal title={title} show={isOpen} desc={desc} image={image} closeModal={closeModal} />
      </div>
    </div>
  );
}

const Construction = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={'64px'}
    viewBox="0 0 817.5 655.499985"
    height={'64px'}
    {...props}
  >
    <path
      fill="#073577"
      d="M 429.613281 19.332031 L 575.046875 19.332031 L 575.046875 271.609375 L 594.515625 271.609375 L 594.515625 9.597656 C 594.515625 4.234375 590.144531 -0.132812 584.78125 -0.132812 L 419.875 -0.132812 C 414.511719 -0.132812 410.140625 4.234375 410.140625 9.597656 L 410.140625 76.542969 L 429.613281 76.542969 Z M 429.613281 19.332031 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <g clipPath="url(#id1)">
      <path
        fill="#073577"
        d="M 809.492188 635.320312 C 752.46875 617.640625 696.242188 604.730469 641.605469 595.59375 L 641.605469 311.933594 C 641.605469 306.570312 637.234375 302.199219 631.871094 302.199219 L 389.476562 302.199219 C 384.113281 302.199219 379.742188 306.570312 379.742188 311.933594 L 379.742188 577.515625 C 362.058594 577.914062 344.574219 578.707031 327.6875 579.703125 L 327.6875 199.300781 C 327.6875 193.9375 323.316406 189.570312 317.953125 189.570312 L 230.730469 189.570312 L 230.730469 126.003906 L 453.851562 126.003906 L 453.851562 271.410156 L 473.320312 271.410156 L 473.320312 116.269531 C 473.320312 110.90625 468.949219 106.535156 463.585938 106.535156 L 220.996094 106.535156 C 215.632812 106.535156 211.261719 110.90625 211.261719 116.269531 L 211.261719 189.570312 L 124.039062 189.570312 C 118.675781 189.570312 114.304688 193.9375 114.304688 199.300781 L 114.304688 607.710938 C 48.144531 621.617188 9.003906 634.925781 7.808594 635.320312 C 2.84375 637.109375 0.0625 642.671875 1.851562 647.636719 C 3.636719 652.601562 9.199219 655.382812 14.167969 653.597656 C 17.347656 652.40625 286.757812 560.433594 622.132812 612.082031 L 622.132812 612.476562 L 624.320312 612.476562 C 682.535156 621.617188 742.535156 634.925781 803.730469 653.796875 C 804.722656 654.191406 805.714844 654.191406 806.511719 654.191406 C 810.683594 654.191406 814.457031 651.609375 815.847656 647.4375 C 817.4375 642.273438 814.65625 636.910156 809.492188 635.320312 Z M 133.773438 209.035156 L 308.414062 209.035156 L 308.414062 580.894531 C 240.664062 585.660156 181.457031 594.601562 133.773438 603.9375 Z M 399.214844 577.121094 L 399.214844 321.46875 L 622.332031 321.46875 L 622.332031 592.414062 C 543.457031 580.695312 468.15625 576.523438 399.214844 577.121094 Z M 399.214844 577.121094 "
        fillOpacity={1}
        fillRule="nonzero"
      />
    </g>
    <path
      fill="#073577"
      d="M 158.015625 236.847656 L 187.019531 236.847656 L 187.019531 256.3125 L 158.015625 256.3125 Z M 158.015625 236.847656 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 206.492188 236.847656 L 235.5 236.847656 L 235.5 256.3125 L 206.492188 256.3125 Z M 206.492188 236.847656 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 254.96875 236.847656 L 283.976562 236.847656 L 283.976562 256.3125 L 254.96875 256.3125 Z M 254.96875 236.847656 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 158.015625 285.316406 L 187.019531 285.316406 L 187.019531 304.78125 L 158.015625 304.78125 Z M 158.015625 285.316406 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 206.492188 285.316406 L 235.5 285.316406 L 235.5 304.78125 L 206.492188 304.78125 Z M 206.492188 285.316406 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 254.96875 285.316406 L 283.976562 285.316406 L 283.976562 304.78125 L 254.96875 304.78125 Z M 254.96875 285.316406 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 158.015625 333.980469 L 187.019531 333.980469 L 187.019531 353.449219 L 158.015625 353.449219 Z M 158.015625 333.980469 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 206.492188 333.980469 L 235.5 333.980469 L 235.5 353.449219 L 206.492188 353.449219 Z M 206.492188 333.980469 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 254.96875 333.980469 L 283.976562 333.980469 L 283.976562 353.449219 L 254.96875 353.449219 Z M 254.96875 333.980469 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 423.453125 349.675781 L 452.460938 349.675781 L 452.460938 369.140625 L 423.453125 369.140625 Z M 423.453125 349.675781 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 471.929688 349.675781 L 549.617188 349.675781 L 549.617188 369.140625 L 471.929688 369.140625 Z M 471.929688 349.675781 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 568.886719 349.675781 L 597.894531 349.675781 L 597.894531 369.140625 L 568.886719 369.140625 Z M 568.886719 349.675781 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 423.453125 398.144531 L 452.460938 398.144531 L 452.460938 417.609375 L 423.453125 417.609375 Z M 423.453125 398.144531 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 471.929688 398.144531 L 549.617188 398.144531 L 549.617188 417.609375 L 471.929688 417.609375 Z M 471.929688 398.144531 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 568.886719 398.144531 L 597.894531 398.144531 L 597.894531 417.609375 L 568.886719 417.609375 Z M 568.886719 398.144531 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 423.453125 446.613281 L 452.460938 446.613281 L 452.460938 466.078125 L 423.453125 466.078125 Z M 423.453125 446.613281 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 471.929688 446.613281 L 549.617188 446.613281 L 549.617188 466.078125 L 471.929688 466.078125 Z M 471.929688 446.613281 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 568.886719 446.613281 L 597.894531 446.613281 L 597.894531 466.078125 L 568.886719 466.078125 Z M 568.886719 446.613281 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 158.015625 382.449219 L 187.019531 382.449219 L 187.019531 401.917969 L 158.015625 401.917969 Z M 158.015625 382.449219 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 206.492188 382.449219 L 235.5 382.449219 L 235.5 401.917969 L 206.492188 401.917969 Z M 206.492188 382.449219 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 254.96875 382.449219 L 283.976562 382.449219 L 283.976562 401.917969 L 254.96875 401.917969 Z M 254.96875 382.449219 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 158.015625 430.917969 L 187.019531 430.917969 L 187.019531 450.386719 L 158.015625 450.386719 Z M 158.015625 430.917969 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 206.492188 430.917969 L 235.5 430.917969 L 235.5 450.386719 L 206.492188 450.386719 Z M 206.492188 430.917969 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 254.96875 430.917969 L 283.976562 430.917969 L 283.976562 450.386719 L 254.96875 450.386719 Z M 254.96875 430.917969 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 158.015625 479.386719 L 187.019531 479.386719 L 187.019531 498.855469 L 158.015625 498.855469 Z M 158.015625 479.386719 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 206.492188 479.386719 L 235.5 479.386719 L 235.5 498.855469 L 206.492188 498.855469 Z M 206.492188 479.386719 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 254.96875 479.386719 L 283.976562 479.386719 L 283.976562 498.855469 L 254.96875 498.855469 Z M 254.96875 479.386719 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 510.671875 252.738281 L 539.679688 252.738281 L 539.679688 272.203125 L 510.671875 272.203125 Z M 510.671875 252.738281 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 510.671875 204.269531 L 539.679688 204.269531 L 539.679688 223.734375 L 510.671875 223.734375 Z M 510.671875 204.269531 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 510.671875 155.800781 L 539.679688 155.800781 L 539.679688 175.265625 L 510.671875 175.265625 Z M 510.671875 155.800781 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 510.671875 107.132812 L 539.679688 107.132812 L 539.679688 126.597656 L 510.671875 126.597656 Z M 510.671875 107.132812 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 510.671875 58.664062 L 539.679688 58.664062 L 539.679688 78.132812 L 510.671875 78.132812 Z M 510.671875 58.664062 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 462.195312 58.664062 L 491.203125 58.664062 L 491.203125 78.132812 L 462.195312 78.132812 Z M 462.195312 58.664062 "
      fillOpacity={1}
      fillRule="nonzero"
    />
  </svg>
);

const Mining = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={86}
    zoomAndPan="magnify"
    viewBox="0 0 1440 809.999993"
    height={86}
    {...props}
  >
    <path
      fill="#073577"
      d="M 636.25 513.730469 L 566.667969 454 L 493.8125 545.636719 L 493.8125 809.910156 L 1246.929688 809.910156 C 1246.929688 809.910156 1246.929688 567.730469 1246.929688 553.820312 L 1160.15625 417.183594 L 948.957031 454 L 898.203125 537.457031 L 815.523438 335.367188 L 700.101562 385.273438 Z M 526.554688 777.183594 L 526.554688 631.546875 C 527.375 631.546875 529.011719 630.730469 529.832031 630.730469 L 577.308594 607 L 777.050781 778 L 526.554688 778 Z M 1214.183594 777.183594 L 827.804688 777.183594 L 732.84375 696.183594 L 818.796875 601.273438 L 905.570312 645.457031 L 930.128906 717.457031 C 931.765625 722.367188 935.859375 725.636719 939.953125 727.273438 C 941.589844 728.09375 943.226562 728.09375 944.863281 728.09375 C 948.136719 728.09375 951.410156 727.273438 953.867188 725.636719 L 1126.59375 611.09375 L 1211.726562 667.546875 C 1211.726562 667.546875 1212.546875 667.546875 1212.546875 668.363281 L 1212.546875 777.183594 Z M 798.332031 378.730469 L 868.734375 549.730469 C 873.644531 561.183594 884.285156 568.546875 896.566406 570.183594 C 897.382812 570.183594 898.203125 570.183594 899.019531 570.183594 C 910.480469 570.183594 921.125 564.457031 926.855469 554.636719 L 969.421875 484.273438 L 1143.785156 453.183594 L 1214.183594 563.636719 L 1214.183594 629.910156 L 1137.234375 578.363281 C 1131.503906 575.09375 1124.957031 575.09375 1119.226562 578.363281 L 955.503906 687.183594 L 935.039062 628.273438 C 933.402344 624.183594 930.945312 620.910156 926.855469 619.273438 L 822.890625 566.910156 C 816.34375 563.636719 808.15625 565.273438 803.246094 570.183594 L 707.46875 674.910156 L 590.40625 574.273438 C 585.496094 570.183594 578.128906 569.363281 572.398438 571.820312 L 526.554688 595.546875 L 526.554688 557.09375 L 571.578125 500.636719 L 614.964844 538.273438 C 620.695312 543.183594 628.882812 546.457031 636.25 546.457031 C 638.707031 546.457031 640.34375 546.457031 642.796875 545.636719 C 652.621094 544 660.808594 537.457031 665.71875 528.457031 L 724.660156 410.636719 Z M 798.332031 378.730469 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 775.414062 328 C 782.78125 328 789.328125 323.09375 790.964844 315.730469 L 810.613281 236.367188 C 813.066406 227.367188 807.335938 218.367188 798.332031 216.730469 C 789.328125 214.273438 780.324219 220 778.6875 229 L 759.039062 308.363281 C 756.585938 317.363281 762.316406 326.367188 771.320312 328 C 772.136719 328 773.773438 328 775.414062 328 Z M 775.414062 328 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 673.085938 373.820312 C 674.722656 373.820312 675.542969 374.636719 677.179688 374.636719 C 684.546875 374.636719 691.097656 369.730469 692.734375 362.367188 C 695.1875 353.367188 689.457031 344.367188 680.453125 342.730469 L 601.050781 323.09375 C 592.042969 320.636719 583.039062 326.367188 581.402344 335.363281 C 578.945312 344.363281 584.675781 353.363281 593.683594 355 Z M 673.085938 373.820312 "
      fillOpacity={1}
      fillRule="nonzero"
    />
    <path
      fill="#073577"
      d="M 208.121094 485.910156 C 193.382812 507.183594 197.476562 536.636719 216.304688 553.820312 C 216.304688 553.820312 217.125 554.636719 217.941406 554.636719 L 246.59375 577.546875 C 255.597656 584.910156 266.238281 589 277.699219 589 C 293.253906 589 307.988281 580.820312 316.175781 567.730469 L 571.578125 202.820312 C 574.035156 203.636719 577.308594 204.457031 580.585938 204.457031 C 581.402344 204.457031 581.402344 204.457031 582.222656 204.457031 C 637.886719 260.09375 670.628906 311.636719 671.449219 312.457031 C 678 322.273438 687.820312 327.183594 699.28125 327.183594 C 703.375 327.183594 708.285156 326.367188 712.378906 324.730469 C 727.113281 318.183594 735.300781 301.820312 731.207031 286.273438 C 713.199219 218.367188 683.726562 166.820312 649.347656 127.546875 C 652.621094 116.910156 649.347656 104.636719 639.523438 97.273438 L 573.21875 46.546875 C 567.488281 41.636719 559.300781 40 551.933594 40.820312 C 547.839844 41.636719 544.566406 42.457031 541.292969 44.910156 C 456.15625 2.367188 374.296875 -0.0898438 358.742188 -0.0898438 C 356.285156 -0.0898438 354.648438 -0.0898438 354.648438 -0.0898438 C 338.277344 0.730469 324.359375 13.820312 323.542969 30.183594 C 322.722656 46.546875 333.367188 62.09375 349.738281 64.546875 C 399.671875 74.367188 445.515625 96.457031 486.445312 124.273438 C 486.445312 130 488.082031 135.730469 491.355469 141.457031 L 209.757812 484.273438 C 208.9375 484.273438 208.9375 485.09375 208.121094 485.910156 Z M 698.464844 294.457031 C 698.464844 294.457031 664.902344 242.910156 608.417969 184.820312 L 629.699219 156.183594 C 658.351562 191.367188 682.910156 236.367188 698.464844 294.457031 Z M 556.027344 75.183594 L 614.964844 120.183594 L 578.945312 169.273438 L 520.007812 124.273438 Z M 354.648438 32.636719 C 354.648438 32.636719 355.46875 32.636719 357.925781 32.636719 C 373.476562 32.636719 444.695312 35.09375 519.1875 70.273438 L 501.179688 94.820312 C 456.976562 66.183594 407.859375 43.273438 354.648438 32.636719 Z M 235.132812 504.730469 L 515.914062 161.910156 L 544.566406 184 L 288.34375 549.730469 C 285.886719 553.820312 280.976562 556.273438 276.882812 556.273438 C 273.609375 556.273438 270.332031 554.636719 267.058594 552.183594 L 238.40625 529.273438 C 231.039062 523.546875 229.402344 512.09375 235.132812 504.730469 Z M 235.132812 504.730469 "
      fillOpacity={1}
      fillRule="nonzero"
    />
  </svg>
);

const It = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="64px"
    zoomAndPan="magnify"
    viewBox="0 0 817.5 817.499979"
    height="64px"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <defs>
      <clipPath id="id1">
        <path
          d="M 16.289062 11.777344 L 802.21875 11.777344 L 802.21875 806.027344 L 16.289062 806.027344 Z M 16.289062 11.777344 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#id1)">
      <path
        fill="#073577"
        d="M 40.476562 759.066406 L 99.425781 597.875 C 105.417969 583.351562 119.871094 587.015625 123.46875 587.015625 L 693.914062 587.015625 C 696.308594 587.015625 713.164062 583.351562 717.957031 597.875 L 776.976562 759.066406 C 780.574219 769.925781 773.308594 781.984375 761.324219 781.984375 L 490.554688 781.984375 L 464.042969 709.777344 C 462.84375 704.914062 458.050781 701.316406 453.253906 701.316406 L 359.332031 701.316406 C 354.539062 701.316406 349.742188 704.914062 347.34375 709.777344 L 325.699219 781.984375 L 57.328125 781.984375 C 45.269531 781.984375 36.808594 769.925781 40.476562 759.066406 Z M 107.816406 52.675781 C 107.816406 43.085938 115.078125 35.820312 123.46875 35.820312 L 693.914062 35.820312 C 702.304688 35.820312 709.566406 43.085938 709.566406 52.675781 L 709.566406 547.246094 C 709.566406 556.90625 702.304688 564.101562 692.714844 564.101562 L 123.46875 564.101562 C 113.878906 564.101562 106.617188 556.90625 106.617188 547.246094 L 106.617188 52.675781 Z M 350.941406 781.984375 L 367.792969 725.363281 L 444.792969 725.363281 L 465.242188 781.984375 Z M 57.328125 806.027344 C 279.9375 806.027344 539.84375 806.027344 761.324219 806.027344 C 790.164062 806.027344 809.410156 777.117188 799.824219 750.675781 L 740.875 589.414062 C 738.40625 580.953125 732.414062 574.957031 726.417969 570.164062 C 731.214844 562.902344 734.808594 554.511719 734.808594 546.046875 L 734.808594 52.675781 C 733.613281 29.828125 715.558594 11.777344 693.914062 11.777344 L 123.46875 11.777344 C 101.820312 11.777344 83.769531 29.828125 83.769531 52.675781 L 83.769531 547.246094 C 83.769531 556.90625 87.367188 565.296875 92.230469 571.363281 C 86.167969 576.15625 80.175781 582.152344 77.777344 590.613281 L 18.828125 750.675781 C 9.167969 777.117188 28.417969 806.027344 57.328125 806.027344 "
        fillOpacity={1}
        fillRule="nonzero"
      />
    </g>
    <path
      fill="#073577"
      d="M 285.929688 311.453125 C 285.929688 329.503906 288.328125 347.558594 290.792969 365.609375 C 278.738281 372.800781 269.078125 386.054688 270.277344 401.710938 C 261.882812 405.304688 253.492188 408.902344 246.230469 412.5 C 224.582031 382.390625 212.527344 347.558594 211.328125 311.453125 Z M 277.539062 424.554688 C 279.9375 425.753906 289.597656 442.605469 313.640625 441.410156 C 322.03125 458.261719 330.492188 473.84375 341.28125 485.902344 C 311.242188 475.042969 284.730469 456.992188 261.882812 431.75 C 266.679688 429.351562 271.542969 426.953125 277.539062 424.554688 Z M 396.632812 311.453125 L 396.632812 377.59375 C 379.851562 377.59375 363 379.992188 347.34375 382.390625 C 341.28125 370.402344 329.292969 363.210938 316.039062 360.742188 C 314.839844 360.742188 314.839844 360.742188 313.640625 360.742188 C 311.242188 345.160156 310.042969 329.503906 308.84375 312.652344 L 396.632812 312.652344 Z M 319.632812 212.738281 C 343.75 218.800781 370.191406 221.199219 396.632812 222.398438 L 396.632812 288.539062 L 310.042969 288.539062 C 310.042969 260.898438 313.640625 235.582031 319.632812 212.738281 Z M 396.632812 102.035156 L 396.632812 197.082031 C 372.589844 195.886719 348.542969 193.488281 326.898438 188.691406 C 342.480469 141.730469 368.992188 109.226562 396.632812 102.035156 Z M 465.242188 193.488281 C 450.785156 195.886719 436.402344 197.082031 420.75 197.082031 L 420.75 102.035156 C 443.59375 108.027344 465.242188 129.675781 480.894531 164.648438 C 472.503906 173.039062 466.441406 181.429688 465.242188 193.488281 Z M 506.210938 181.429688 C 513.402344 181.429688 520.59375 186.296875 521.792969 193.488281 C 524.261719 203.148438 518.195312 212.738281 509.804688 215.136719 C 500.144531 217.53125 491.753906 211.539062 489.355469 201.878906 C 486.890625 192.289062 494.152344 181.429688 506.210938 181.429688 Z M 420.75 287.339844 L 420.75 222.398438 C 437.601562 222.398438 454.453125 219.929688 470.105469 217.53125 C 477.300781 230.789062 489.355469 237.980469 502.542969 239.25 C 504.941406 254.902344 506.210938 271.6875 507.40625 287.339844 Z M 497.746094 386.054688 C 473.703125 379.992188 448.390625 377.59375 420.75 376.394531 L 420.75 310.183594 L 507.40625 310.183594 C 507.40625 337.898438 503.742188 363.210938 497.746094 386.054688 Z M 420.75 496.761719 L 420.75 401.710938 C 444.792969 402.910156 468.839844 405.304688 490.554688 410.101562 C 474.902344 456.992188 448.390625 489.570312 420.75 496.761719 Z M 350.941406 405.304688 C 365.394531 402.910156 381.050781 401.710938 396.632812 401.710938 L 396.632812 496.761719 C 373.789062 490.695312 352.140625 467.851562 335.289062 433.019531 C 343.75 426.953125 350.941406 416.09375 350.941406 405.304688 Z M 311.242188 383.660156 C 319.632812 383.660156 325.699219 389.652344 328.09375 396.84375 C 329.292969 404.109375 325.699219 412.5 317.238281 416.09375 C 307.648438 419.691406 294.390625 412.5 294.390625 400.441406 C 294.390625 390.851562 301.582031 383.660156 311.242188 383.660156 Z M 477.300781 485.902344 C 491.753906 467.851562 504.941406 445.003906 514.601562 416.09375 C 530.253906 420.890625 543.511719 425.753906 556.695312 433.019531 C 533.851562 456.992188 507.40625 475.042969 477.300781 485.902344 Z M 571.152344 413.699219 C 556.695312 405.304688 539.84375 398.042969 520.59375 393.25 C 526.65625 368.003906 530.253906 340.292969 531.453125 312.652344 L 606.054688 312.652344 C 604.855469 348.753906 592.796875 383.660156 571.152344 413.699219 Z M 607.253906 287.339844 L 532.652344 287.339844 C 532.652344 269.289062 530.253906 251.238281 527.855469 233.1875 C 539.84375 225.992188 548.304688 212.738281 548.304688 198.28125 C 556.695312 194.6875 565.15625 191.089844 572.351562 186.296875 C 592.796875 216.332031 604.855469 250.039062 607.253906 287.339844 Z M 555.496094 167.046875 C 550.703125 169.441406 544.710938 171.839844 539.84375 174.238281 C 532.652344 163.378906 519.394531 156.1875 506.210938 156.1875 C 504.941406 156.1875 504.941406 156.1875 503.742188 156.1875 C 495.351562 139.335938 486.890625 123.679688 476.101562 111.621094 C 508.605469 124.878906 535.050781 142.929688 555.496094 167.046875 Z M 340.082031 112.890625 C 325.699219 130.941406 312.441406 154.988281 302.78125 182.699219 C 287.128906 177.832031 273.941406 173.039062 260.6875 165.777344 C 283.53125 142.929688 308.84375 124.878906 340.082031 112.890625 Z M 246.230469 186.296875 C 260.6875 194.6875 277.539062 201.878906 296.789062 206.742188 C 290.792969 231.988281 287.128906 259.699219 285.929688 287.339844 L 211.328125 287.339844 C 212.527344 250.039062 224.582031 216.332031 246.230469 186.296875 Z M 408.691406 522.003906 C 532.652344 522.003906 631.296875 422.160156 631.296875 299.398438 C 631.296875 163.378906 509.804688 68.328125 403.894531 76.789062 C 279.9375 79.1875 186.082031 180.230469 186.082031 299.398438 C 186.082031 420.890625 283.53125 522.003906 408.691406 522.003906 "
      fillOpacity={1}
      fillRule="nonzero"
    />
  </svg>
);
